import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SFFormBuilder } from "@sf-core";
import { nanoid } from "@reduxjs/toolkit";
import getSchema from "./schema.js";
import getUIschema from "./uischema.js";
import { getExecutionFlowTypes } from "../../../services/executionFlowService";

const NewExecutionFlowForm = ({ onChange, data }) => {
  const [schema, setSchema] = useState(null);
  const [uiSchema, setUiSchema] = useState(null);
  const [executionFlowTypes, setExecutionFlowTypes] = useState(nanoid());
  useEffect(async () => {
    getExecutionFlowTypes().then((res) => {
      setExecutionFlowTypes(res.data);
      setSchema(getSchema(res.data));
    });

    setUiSchema(getUIschema());
  }, []);

  useEffect(() => {
    if (executionFlowTypes && data.executionFlowTypeId) {
      let parameters = JSON.parse(
        executionFlowTypes.find((x) => x.id === data.executionFlowTypeId)
          ?.parameterSchema
      );
      setSchema(getSchema(executionFlowTypes, parameters));
      setUiSchema(getUIschema(parameters));
    }
  }, [executionFlowTypes?.length, data.executionFlowTypeId]);

  if (!schema) {
    return null;
  }

  return (
    <SFFormBuilder
      schema={schema}
      uischema={uiSchema}
      data={data}
      onChange={onChange}
    />
  );
};

NewExecutionFlowForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default NewExecutionFlowForm;
